import styled from 'styled-components';

export const EditDocumentCategory = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  .to-center {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
